module.exports = "#define GLSLIFY 1\n#ifdef USE_FOG\n\n\tfogDepth = -mvPosition.z;\n\n#endif\n"